import PropTypes from "prop-types";
const PropTypeHeading = {
  type: PropTypes.string,
  className: PropTypes.string,
  /** This takes the component is RTF */
  html: PropTypes.string
};

export default PropTypeHeading;
